import React from 'react';
import './BtnMembership.scss';
import { useMediaQuery } from '@material-ui/core';

const BtnMembership = ({textBtn, handleClick, hovered}) => {

    const isMobile = useMediaQuery('(max-width: 768.98px)')

    return ( 
        <div
            onClick={handleClick}
            className={`ButtonMemberships
                ${hovered || isMobile ? 'hovered-btn' : 'active-btn'}`
            }
        >
            <div className='center-container'>
                <p className='text-btn'>
                    {textBtn}
                </p>
            </div>
        </div>
    );
}
 
export default BtnMembership;

